/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActivePaymentsToArchiveDto
 */
export interface ActivePaymentsToArchiveDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ActivePaymentsToArchiveDto
     */
    statuses: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ActivePaymentsToArchiveDto
     */
    hoursSinceUpdated: number;
    /**
     * 
     * @type {number}
     * @memberof ActivePaymentsToArchiveDto
     */
    limit: number;
}

/**
 * Check if a given object implements the ActivePaymentsToArchiveDto interface.
 */
export function instanceOfActivePaymentsToArchiveDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "statuses" in value;
    isInstance = isInstance && "hoursSinceUpdated" in value;
    isInstance = isInstance && "limit" in value;

    return isInstance;
}

export function ActivePaymentsToArchiveDtoFromJSON(json: any): ActivePaymentsToArchiveDto {
    return ActivePaymentsToArchiveDtoFromJSONTyped(json, false);
}

export function ActivePaymentsToArchiveDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivePaymentsToArchiveDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'statuses': json['statuses'],
        'hoursSinceUpdated': json['hoursSinceUpdated'],
        'limit': json['limit'],
    };
}

export function ActivePaymentsToArchiveDtoToJSON(value?: ActivePaymentsToArchiveDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'statuses': value.statuses,
        'hoursSinceUpdated': value.hoursSinceUpdated,
        'limit': value.limit,
    };
}

